// extracted by mini-css-extract-plugin
export default {"bubbleModuleTable":"BubbleModuleTable__bubbleModuleTable___AK3Tq","header":"BubbleModuleTable__header___KQoGI","addBtn":"BubbleModuleTable__addBtn___i8Kc4"};